import { createSelector, createSlice } from '@reduxjs/toolkit';
import _isNil from 'lodash/isNil';
import { ITeam } from '@Data/teams/Interfaces';
import { teamMembersState } from '@Data/teams/Reducer';
import { ITeamState } from '@Data/teams/State';
import { IUser } from '@Data/users/Interfaces';
import { RootState } from '@Services/redux/Store';
import { IOrganization } from './Interfaces';
import { IOrganizationState, initialOrganizationState } from './State';

const OrganizationSlice = createSlice({
    name: 'Organization',
    initialState: initialOrganizationState,
    reducers: {
        updateOrganizations(state, action) {
            state.organizations = action.payload;
        },
        setSelectedOrganization(state, action) {
            state.selectedOrganization = action.payload;
        },
        updateOrganizationMembers(state, action) {
            state.organizationMembers = action.payload;
        },
        updateOrganizationAdministrators(state, action) {
            state.organizationAdministrators = action.payload;
        },
        //return to initialstate
        clearOrganizationState(state) {
            state.organizations = [];
            state.organizationMembers = [];
            state.organizationAdministrators = [];
            state.selectedOrganization = null;
            state.teams = [];
        },
    },
});

export const OrganizationActions = OrganizationSlice.actions;

export const organizationsState = (state: RootState): IOrganization[] =>
    state.organization.organizations;
export const activeOrganizationsState = createSelector(
    organizationsState,
    (orgs) => {
        return _isNil(orgs) ? null : orgs.filter((o) => o.is_active);
    }
);
export const selectedOrganizationState = (state: RootState): IOrganization =>
    state.organization.selectedOrganization;
export const organizationMembersState = (state: RootState): IUser[] =>
    state.organization.organizationMembers;
export const organizationAdministratorsState = (state: RootState): IUser[] =>
    state.organization.organizationAdministrators;
export const orgMembersNotInTeamState = createSelector(
    organizationMembersState,
    teamMembersState,
    (orgMembers, teamMembers) => {
        return orgMembers.filter(
            (m) => !teamMembers.some((t) => t.user_id === m.user_id)
        );
    }
);

export default OrganizationSlice.reducer;
